import { PublicationListData } from "@/components/business/PublicationListContainer/publicationList.types";
import { ProcessStatusCode } from "@/types/code.types";
import { useCreateEntryDataMutation } from "@api/createEntryData/createEntryData";
import { DRAFT_STATUS_CODE } from "@constants/draftStatusCode.constants";
import { handlePublicationListError } from "@utils/handleDraftError";

import Status from "./components/Status/Status";

type Props = {
  data: PublicationListData;
};

const ListStatusContainer = ({ data }: Props) => {
  const { mutateAsync: createEntryData } = useCreateEntryDataMutation();

  const checkDisabledStatusButton = (status: ProcessStatusCode) => {
    if (status !== DRAFT_STATUS_CODE.aiEntryDone) return false;
    return true;
  };

  const createDAE = (id: number) => {
    createEntryData(id);
  };

  return (
    <Status
      data={data}
      isDraftError={handlePublicationListError(data)[0]}
      draftErrorMessage={handlePublicationListError(data)[1]}
      createDAE={createDAE}
      disabled={checkDisabledStatusButton(data.draftArticleStatusHighest)}
    />
  );
};

export default ListStatusContainer;
